import AbstractNormalizersResolver from "../../core/AbstractNormalizersResolver";
import CheckAvailabilityNormalizer from "./CheckAvailabilityNormalizer";
export default class CheckAvailabilityNormalizersResolver extends AbstractNormalizersResolver {
    register() {
        return [
            new CheckAvailabilityNormalizer(),
        ];
    }
}
